<template>
  <div class="main-page-div" role="main" aria-label="Dashboard Score Page">
    <v-container fluid class="redesign-main-page-container">
      <v-card class="main-content-card" elevation="0">
        <!-- Title and Reprocess Button Section   -->
        <v-row no-gutters align="center">
          <v-col cols="12" md="6">
            <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('dashboardScore') }}</h1>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end align-middle">
            <v-btn id="button-reprocess-dashboardscore" :loading="loadingbtn" variant="elevated" color="primary"
              size="large" class="control-btn create-btn" @click="OpenDialogReprocess()" prepend-icon="mdi-cached">
              <span class="btn-text">{{ "REPROCESS" }}</span>
              <v-tooltip activator="parent" location="top">
                Reprocess Dashboard Score
              </v-tooltip>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Old Action and Content Section -->
        <!-- <v-row>
          <v-col cols="12" sm="12" md="7">
            <v-btn id="button-reprocess-dashboardscore" :loading="loadingbtn" variant="flat" color="purple-darken-1"
              size="large" class="reprocess-btn mt-3" style="margin-left: 1em; width: 140px; height: 44px"
              @click="OpenDialogReprocess()" prepend-icon="mdi-refresh">
              REPROCESS
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="4" class="mt-3">
            <v-autocomplete id="validationprocess-autocomplete-dashboardscore" label="Validation process"
              :items="DDValidationProcess" item-title="name" item-value="id" clearable variant="outlined"
              density="comfortable" color="primary" v-model="ProcessID" hide-details="auto" class="modern-field"
              ref="auto">
              <template v-slot:item="{ props, item, index }">
                <v-list-item v-bind="props" :id="'validationprocess-option-' + index" :value="item.raw.name">
                  <template v-slot:title>
                    <span>{{ item.raw.name }}</span>
                  </template>
</v-list-item>
</template>
<template v-slot:prepend-inner>
                <v-icon color="primary" size="small">mdi-cog-outline</v-icon>
              </template>
<template v-slot:append-inner>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="grey-darken-1" size="small">
                      mdi-information-outline
                    </v-icon>
                  </template>
<span>Select validation process to view dashboard score</span>
</v-tooltip>
</template>
</v-autocomplete>
</v-col>
<v-col cols="12" sm="12" md="1" class="mt-4" style="display: flex; align-items: center;">
  <v-btn id="button-search-dashboardscore" icon variant="flat" color="primary" size="large" class="search-btn"
    @click="SearchData" :disabled="!ProcessID">
    <v-icon size="24">mdi-magnify</v-icon>
    <v-tooltip activator="parent" location="top">
      {{ $t('search') }}
    </v-tooltip>
  </v-btn>
</v-col>
<v-col cols="12" sm="12" md="7">
  <v-card class="card-2">
    <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
  </v-card>
</v-col>
<v-col cols="12" sm="12" md="5">
  <v-card class="card-1 d-flex align-center mb-6">
    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="currentColor" class="bi bi-bar-chart-line-fill"
      viewBox="0 0 16 16" style="margin-left: 1em; color: #1976d2">
      <path
        d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z" />
    </svg>
    <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 18px">
      {{ $t('averageScore') }}
      <br /><span id="averagescore" style="color: #8e8e8e; font-size: 40px">{{ averageScore }} {{ $t('score')
        }}</span>
    </label>
  </v-card>
  <v-card class="card-1 d-flex align-center mb-6">
    <div style="border-radius: 5px; padding-left: 1em; font-weight: 700; font-size: 14px">
      <v-row style="margin-top: 0px;">
        <v-col style="margin-top: 0px;">
          <label style="font-size: 12px;">Model Name : {{ ModelName }}</label>
        </v-col>
      </v-row>
      <v-row style="margin-top: 0px;">
        <v-col style="margin-top: 0px;">
          <label style="font-size: 12px;">Versioning : {{ Version }}</label>
        </v-col>
      </v-row>
      <v-row style="margin-top: 0px;">
        <v-col style="margin-top: 0px;">
          <label style="font-size: 12px;">Processing Date : {{ processDate }}</label>
        </v-col>
      </v-row>
    </div>
  </v-card>
  <v-card class="card-1 d-flex align-center mb-6">
    <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 14px">
      {{ $t('conditionScore0') }}
      <br />
      {{ $t('conditionScore1') }}
      <br />
      {{ $t('conditionScore2') }}
    </label>
  </v-card>

</v-col>
</v-row> -->

        <!-- New Section for Area Chart and Score Data -->
        <v-row>
          <v-col cols="12" md="6">
            <v-row align="end" no-gutters>
              <!-- Left -->
              <v-col class="d-flex">
                <div class="d-flex flex-column w-100 pr-5">
                  <label class="input-label">
                    Validation Process
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div>Select validation process to view dashboard score.</div>
                    </v-tooltip>
                  </label>

                  <v-autocomplete id="validationprocess-autocomplete-dashboardscore" :items="DDValidationProcess"
                    item-title="name" item-value="id" clearable variant="outlined" density="comfortable" color="#DCDCDC"
                    v-model="ProcessID" hide-details="auto" class="modern-field" ref="auto">
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'validationprocess-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <!-- Right -->
              <v-col cols="auto" class="d-flex align-end">
                <v-btn id="button-search-dashboardscore" class="search-btn-circular" icon size="large"
                  @click="SearchData" aria-label="Search dashboard score" :disabled="!ProcessID">
                  <v-icon size="30" color="white">mdi-magnify</v-icon>
                  <v-tooltip activator="parent" location="top">
                    {{ $t('search') }}
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="d-flex flex-column mt-4">
                <v-card class="card-1 d-flex align-center">
                  <div class="d-flex flex-row pl-3">
                    <v-img :src="chartScoreImg" alt="Chart Score" width="76" height="96" contain></v-img>
                    <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 18px">
                      {{ $t('averageScore') }}
                      <br /><span id="averagescore" style="color: #8e8e8e; font-size: 40px">{{ averageScore }} {{
                        $t('score')
                      }}</span>
                    </label>
                  </div>
                </v-card>
                <v-card class="card-1 d-flex align-center mt-4">
                  <div style="border-radius: 5px; padding-left: 1em; font-weight: 700; font-size: 14px">
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <label style="font-size: 12px;">Model Name : {{ ModelName }}</label>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <label style="font-size: 12px;">Versioning : {{ Version }}</label>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <label style="font-size: 12px;">Processing Date : {{ processDate }}</label>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
                <v-card class="card-1 d-flex align-center mt-4">
                  <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 14px">
                    {{ $t('conditionScore0') }}
                    <br />
                    {{ $t('conditionScore1') }}
                    <br />
                    {{ $t('conditionScore2') }}
                  </label>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-end">
            <v-card class="card-2">
              <div class="d-flex align-center" style="gap: 4px; padding: 16px 16px 0 16px;">
                <label class="text-gray-700" style="font-weight: 600; font-size: 18px;">
                  {{ $t('validationScore') }}
                </label>
                <v-tooltip location="top" max-width="320px">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="18" color="grey-darken-1" style="cursor: pointer;">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>Display the evaluation results generated from the selected validation process to assess model
                    accuracy
                    and performance.</span>
                </v-tooltip>
              </div>
              <highcharts v-if="isChartOptions" :options="chartOptions" style="padding: 8px;"></highcharts>
            </v-card>
          </v-col>
        </v-row>

        <!-- Table -->
        <v-row no-gutters class="mt-4">
          <v-col cols="12" sm="12" md="12">
            <v-data-table-server :items-per-page="options.itemsPerPage" :items-length="searchTotalTable"
              v-model:options="options" :items="dataTable" :headers="headers">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: left">{{ item.number }}</td>
                  <td style="text-align: left; max-width: 300px;">
                    <div class="expandable-text-wrapper">
                      <div :class="{'text-collapsed': !isRowExpanded(item.number, 'question'), 'text-expanded': isRowExpanded(item.number, 'question')}">
                        {{ item.question }}
                      </div>
                      <v-tooltip location="top" v-if="shouldShowExpandIcon(item.question)">
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon
                            size="x-small"
                            variant="text"
                            @click="toggleRowExpansion(item.number, 'question')"
                            class="expand-icon-btn"
                          >
                            <v-icon size="25" :color="'#001763'">
                              {{ isRowExpanded(item.number, 'question') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ isRowExpanded(item.number, 'question') ? 'See less' : 'See more' }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td style="text-align: left; max-width: 300px;">
                    <div class="expandable-text-wrapper">
                      <div :class="{'text-collapsed': !isRowExpanded(item.number, 'answer'), 'text-expanded': isRowExpanded(item.number, 'answer')}">
                        {{ item.answer }}
                      </div>
                      <v-tooltip location="top" v-if="shouldShowExpandIcon(item.answer)">
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon
                            size="x-small"
                            variant="text"
                            @click="toggleRowExpansion(item.number, 'answer')"
                            class="expand-icon-btn"
                          >
                            <v-icon size="25" :color="'#001763'">
                              {{ isRowExpanded(item.number, 'answer') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ isRowExpanded(item.number, 'answer') ? 'See less' : 'See more' }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td style="text-align: left">{{ item.humanAnswer ?? '-' }}</td>
                  <td style="text-align: left">{{ item.score ?? '-' }}</td>
                  <td style="text-align: left;max-width: 300px;">{{ formatChatWorkflowLabel(item.chatWorkFlow) }}</td>
                </tr>
              </template>
              <template v-slot:bottom>
                <div class="table-bottom-group mt-4">
                  <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                    <div class="d-flex flex-column">
                      <span>Total results {{ searchTotalTable }}</span>
                    </div>

                    <v-data-table-footer :items-per-page-options="itemsPerPageOptions"
                      v-model:items-per-page="options.itemsPerPage" v-model:page="options.page" :length="pageCount" />
                  </div>
                </div>
              </template>
            </v-data-table-server>
          </v-col>
        </v-row>
      </v-card>
    </v-container>


    <v-dialog v-model="dialogReprocess" max-width="800px" class="modern-dialog">
      <v-card class="dialog-card">
        <v-card-title class="px-5 py-4 dialog-title-border-bottom">
          <span class="dialog-title">{{ $t('_Reprocess') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0" fluid>
            <v-row no-gutters>
              <v-col cols="6" sm="6" md="6">
                <div class="d-flex flex-column w-100 pr-5">
                  <label class="input-label">
                    Select Model
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ "Select the specific AI model version to be used for all subsequent generative tasks." }}</span>
                    </v-tooltip>
                  </label>

                  <v-autocomplete placeholder="Model Name" :items="DDGPTModel" item-title="name" item-value="modelDisplayID"
                    clearable variant="outlined" density="comfortable" color="#a0a0a0" v-model="Reprocess.modelId"
                    :rules="[rules.required]" required class="modern-field" hide-details="auto">
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col cols="6" sm="6" md="6" class="d-flex align-center">
                <div class="border-section-wrapper">
                  <v-checkbox v-model="Reprocess.isScore" color="#C32E0E" hide-details>
                    <template v-slot:label>
                      <div class="checkbox-label-wrapper">
                        <!-- <v-icon size="small" color="primary" class="mr-2">mdi-calculator</v-icon> -->
                        <span>{{ $t('calculateScores') }}</span>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ "Trigger the scoring mechanism to evaluate the results of the model test against the expected answers." }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-show="Reprocess.isScore" class="mt-3">
                <label class="input-label">
                    Prompt
                    <v-tooltip location="top" max-width="300">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="18" class="info-icon" color="grey-darken-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ "Enter the text used to instruct the generative AI model on the desired output or task to be performed." }}</span>
                    </v-tooltip>
                  </label>
                <v-textarea variant="outlined" counter auto-grow rows="15" v-model="Reprocess.Prompt"
                  required color="#a0a0a0" class="modern-textarea" hide-details="auto">
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions class="dialog-action-border-top">
          <v-spacer></v-spacer>
          <v-btn id="button-close-popupedit-usermanagement" variant="outlined" color="grey"
            @click="CloseDialogReprocess()" class="dialog-action-btn cancel-btn">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn id="button-save-popupedit-usermanagement" variant="elevated" @click="ReProcess()"
            class="dialog-action-btn save-btn-edit">
            <v-img :src="newSaveImg" alt="Reprocess User Dialog" class="image-icon-style"></v-img>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import Cookies from 'js-cookie';
import chartScoreImg from '@/assets/Icons/red-chart-fill.svg';
import newSaveImg from "@/assets/Icons/white-save-floppy.svg";
import { getChatWorkflowLabel } from '@/utils/flowUtils';

export default {
  name: 'DashboardScore',
  inject: ['FontColorTitle'],
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    headers() {
      return [
        { title: this.$t('no'), align: 'left', sortable: false },
        { title: this.$t('question'), align: 'left', sortable: true, value: 'Question' },
        { title: this.$t('answer'), align: 'left', sortable: true, value: 'Answer' },
        { title: this.$t('HumanAnswer'), align: 'left', sortable: true, value: 'HumanAnswer' },
        { title: this.$t('score'), align: 'left', sortable: true, value: 'Score' },
        { title: this.$t('Chat work flow'), align: 'left', sortable: false, value: 'ChatWorkFlow' },
      ];
    },
  },

  watch: {
    currentLanguage(newLanguage) {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.loadTranslations(newLanguage); // เรียกฟังก์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.GetTable();
      },
      deep: true,
    },
  },
  components: {
    highcharts: Chart,
  },
  data: () => ({
    newSaveImg: newSaveImg,
    chartScoreImg: chartScoreImg,
    props: ['id'],
    mask: '##########',
    isInitialized: false,
    show1: false,
    dialog: false,
    loading: false,
    loadingbtn: false,
    userList: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    expandedRows: {},
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    userId: Cookies.get('userId'),
    today: null,
    averageScore: 0,
    graphcategories: [],
    graphdata: [],
    language: 'th',
    DDValidationProcess: [],
    ProcessID: null,
    ModelID: null,
    ModelName: null,
    Version: null,
    processDate: null,

    rules: {
      required: (value) => !!value || 'Required',
    },
    isChartOptions: false,
    chartOptions: {
      chart: {
        type: "area",
        backgroundColor: "transparent",
        spacing: [16, 8, 8, 8],
      },
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      legend: {
        enabled: false
      },
      xAxis: {
        categories: ['0', '1', '2'],
        tickLength: 0,
        tickInterval: 1,
        lineColor: '#F0F0F0',
        labels: {
          step: 1,
          style: { color: '#A3A3A3', fontSize: '12px' },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Data',
          style: { color: '#A3A3A3', fontSize: '12px' },
          rotation: 270,
          margin: 15
        },
        gridLineColor: '#F5F5F5',
        labels: {
          style: { color: '#A3A3A3', fontSize: '12px' },
        },
      },
      tooltip: {
        enabled: true,
        backgroundColor: '#ffffff',
        borderColor: '#e0e0e0',
        borderRadius: 8,
        shadow: true,
        style: {
          color: '#171717',
          fontSize: '12px',
        },
        headerFormat: '<span style="font-size:12px; font-weight: 600;">{point.key}</span><br/>',
        pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.y}</b>',
        shared: false,
        useHTML: false,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: true,
            radius: 4,
            fillColor: '#F18A7E',
            lineWidth: 2,
            lineColor: '#ffffff',
            states: {
              hover: {
                enabled: true,
                radius: 6
              }
            }
          },
          lineWidth: 2,
          states: {
            hover: {
              lineWidth: 2,
            },
          },
        },
      },
      series: [
        {
          type: 'area',
          name: 'Number of data',
          data: [0, 3, 3],
          color: '#F18A7E',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(241, 138, 126, 0.9)'],
              [1, 'rgba(241, 138, 126, 0)'],
            ],
          },
          lineWidth: 2,
        },
      ],

    },
    sortBy: [],
    sortDesc: [],
    dialogReprocess: false,
    DDGPTModel: [],
    Prompt: null,
    IsScore: false,
    Reprocess: {
      modelId: null,
      isScore: false,
      Prompt: null,
    }
  }),
  methods: {
    loadTranslations(newLanguage) {
      this.language = newLanguage;
      // Title is now handled by card header UI
      this.chartOptions.title = { text: '' };
      this.chartOptions.legend = { enabled: false };
      const yAxisMax = this.calculateYAxisMax(this.graphdata || []);
      const tickInterval = this.calculateTickInterval(yAxisMax);
      this.chartOptions.yAxis = {
        min: 0,
        max: yAxisMax,
        title: {
          text: this.$t('NumberData'),
          style: { color: '#A3A3A3', fontSize: '12px' },
          rotation: 270,
          margin: 15
        },
        tickInterval: tickInterval,
        gridLineColor: '#F5F5F5',
        labels: {
          style: { color: '#A3A3A3', fontSize: '12px' },
        },
      };
      this.chartOptions.plotOptions = {
        area: {
          marker: {
            enabled: true,
            radius: 4,
            fillColor: '#F18A7E',
            lineWidth: 2,
            lineColor: '#ffffff',
            states: {
              hover: {
                enabled: true,
                radius: 6
              }
            }
          },
          lineWidth: 2,
          states: {
            hover: {
              lineWidth: 2,
            },
          },
        },
      };
      this.chartOptions.series = [
        {
          type: 'area',
          name: this.$t('NumberData'),
          data: this.graphdata,
          color: '#F18A7E',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(241, 138, 126, 0.9)'],
              [1, 'rgba(241, 138, 126, 0)'],
            ],
          },
          lineWidth: 2,
        },
      ];
    },
    ConvertFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    formatChatWorkflowLabel(value) {
      return getChatWorkflowLabel(value);
    },
    roundToTwoDecimalPlaces(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100;
    },
    calculateYAxisMax(data) {
      // Find the max value in the data
      const maxValue = Math.max(...data, 0);
      // Add 20% padding and round up to next nice number
      const paddedMax = maxValue * 1.2;
      // Round up to next multiple of 5 or 10 depending on scale
      if (paddedMax <= 10) {
        return Math.ceil(paddedMax / 2) * 2 || 10; // Round to nearest 2, minimum 10
      } else if (paddedMax <= 50) {
        return Math.ceil(paddedMax / 10) * 10; // Round to nearest 10
      } else {
        return Math.ceil(paddedMax / 20) * 20; // Round to nearest 20 for larger values
      }
    },
    calculateTickInterval(maxValue) {
      if (maxValue <= 10) return 2;
      if (maxValue <= 50) return 10;
      return 20;
    },
    shouldShowExpandIcon(text) {
      if (!text) return false;
      // Check if text has more than 3 lines
      const lines = text.split('\n').length;
      if (lines > 3) return true;
      // For single-line text, estimate based on character count (assuming ~60 chars per line at max-width: 300px)
      const estimatedLines = Math.ceil(text.length / 60);
      return estimatedLines > 3;
    },
    isRowExpanded(rowId, column) {
      const key = `${rowId}-${column}`;
      return this.expandedRows[key] || false;
    },
    toggleRowExpansion(rowId, column) {
      const key = `${rowId}-${column}`;
      this.expandedRows[key] = !this.expandedRows[key];
    },
    GetTable() {
      let self = this;
      self.dialog = true;
      self.loading = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        ProcessID: self.ProcessID,
        UserID: self.userId,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    SearchData() {
      let self = this;
      self.Get();
      self.GetTable();
    },
    Get() {
      let self = this;
      self.dialog = true;
      this.options.page = 1;
      let temp = {
        ProcessID: self.ProcessID,
        UserID: self.userId,
      };
      self.$call.GetDashboardValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const data = dataResponse.data;
            self.averageScore = self.roundToTwoDecimalPlaces(data.averageScore);
            self.graphcategories = data.categories;
            self.graphdata = data.data;
            self.ModelID = data.modelDisplayID;
            self.ModelName = data.modelName;
            self.Version = data.version;
            self.Prompt = data.prompt;
            self.IsScore = data.isScore;
            self.processDate = data.processDate;
            self.chartOptions.chart = {
              type: 'area',
              backgroundColor: 'transparent',
              spacing: [16, 8, 8, 8],
            };
            self.chartOptions.legend = { enabled: false };
            self.chartOptions.xAxis = {
              categories: self.graphcategories,
              tickLength: 0,
              tickInterval: 1,
              lineColor: '#F0F0F0',
              labels: {
                step: 1,
                style: { color: '#A3A3A3', fontSize: '12px' },
              },
            };
            // Title is handled by card header UI
            self.chartOptions.title = { text: '' };
            self.chartOptions.subtitle = { text: '' };
            const yAxisMax = self.calculateYAxisMax(self.graphdata);
            const tickInterval = self.calculateTickInterval(yAxisMax);
            self.chartOptions.yAxis = {
              min: 0,
              max: yAxisMax,
              title: {
                text: self.$t('NumberData'),
                style: { color: '#A3A3A3', fontSize: '12px' },
                rotation: 270,
                margin: 15
              },
              tickInterval: tickInterval,
              gridLineColor: '#F5F5F5',
              labels: {
                style: { color: '#A3A3A3', fontSize: '12px' },
              },
            };
            self.chartOptions.plotOptions = {
              area: {
                marker: {
                  enabled: true,
                  radius: 4,
                  fillColor: '#F18A7E',
                  lineWidth: 2,
                  lineColor: '#ffffff',
                  states: {
                    hover: {
                      enabled: true,
                      radius: 6
                    }
                  }
                },
                lineWidth: 2,
                states: {
                  hover: {
                    lineWidth: 2,
                  },
                },
              },
            };
            self.chartOptions.series = [
              {
                type: 'area',
                name: self.$t('NumberData'),
                data: self.graphdata,
                color: '#F18A7E',
                fillColor: {
                  linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                  stops: [
                    [0, 'rgba(241, 138, 126, 0.9)'],
                    [1, 'rgba(241, 138, 126, 0)'],
                  ],
                },
                lineWidth: 2,
              },
            ];

            self.isChartOptions = true;
          }
          self.GetDDValidationProcess();
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDValidationProcess() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDValidationProcess(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationProcess = dataResponse.data;
          } else {
            self.DDValidationProcess = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ProcessingScore() {
      let self = this;
      self.$swal.fire({
        title: this.$t('vectorReprocess'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('cancel'),

      }).then((result) => {
        if (result.isConfirmed) {
          self.dialog = true;
          self.loadingbtn = true;
          let temp = {
            ProcessID: self.ProcessID,
            UserID: self.userId,
          };
          self.$call.GenerateValidationScore(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.$router.push('/ValidationProcess');
              }
              self.dialog = false;
              self.loadingbtn = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.loadingbtn = false;
              console.error(errorResource);
            }
          );
        }
      })

    },
    convertDateToStringEn(date, seperator = '/') {
      return dateUtils.getStringWithMonthEnNameFromDate(moment(date).toDate(), seperator);
    },
    convertDateToStringTh(date, seperator = '/') {
      return dateUtils.getStringWithMonthNameFromDate(moment(date).toDate(), seperator);
    },
    OpenDialogReprocess() {
      let self = this;
      self.dialogReprocess = true;
      self.Reprocess.modelId = self.ModelID;
      self.Reprocess.isScore = self.IsScore;
      self.Reprocess.Prompt = self.Prompt;
    },
    CloseDialogReprocess() {
      let self = this;
      self.dialogReprocess = false;
      self.Reprocess.modelId = null;
      self.Reprocess.isScore = false;
      self.Reprocess.Prompt = null;
    },
    ReProcess() {
      let self = this;
      console.log(self.Reprocess);
      console.log(self.CheckNullInVariable(self.Reprocess.modelId));
      if (!self.CheckNullInVariable(self.Reprocess.modelId)) {
        self.$swal.fire({
          title: self.$t("warning"),
          icon: "warning",
          html: "Please select a model.",
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("ok"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
          },
        });
        // self.$swal.fire({
        //   icon: "warning",
        //   title: self.$t("warning"),
        //   text: "Please select a model.",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        return false;
      }
      else if (self.Reprocess.isScore == true && !self.CheckNullInVariable(self.Reprocess.Prompt)) {
        self.$swal.fire({
          title: self.$t("warning"),
          icon: "warning",
          html: "Please enter the prompt.",
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("ok"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
          },
        });
        // self.$swal.fire({
        //   icon: "warning",
        //   title: self.$t("warning"),
        //   text: "Please enter the prompt.",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        return false;
      }
      self.dialog = true;
      self.loadingbtn = true;
      let temp = {
        ProcessID: self.ProcessID,
        ModelID: self.Reprocess.modelId,
        IsScore: self.Reprocess.isScore,
        Prompt: self.Reprocess.Prompt,
      };
      self.$call.SetReprocessValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              title: "✔ Successfully Reprocess !",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
            self.$router.push('/ValidationProcess');
          }
          self.dialog = false;
          self.loadingbtn = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingbtn = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          // self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    CheckNullInVariable(variable) {
      if (variable == null || variable == undefined || variable == "") {
        return false;
      }
      else {
        return true;
      }
    },
  },
  mounted() {
    let self = this;
    self.language = self.$i18n.locale;
    self.GetDDGPTModel();
    if (self.$route.query.id) {
      if (self.$route.query.id != null) {
        self.ProcessID = self.$route.query.id;
        self.Get();
      }
    }
    self.GetTable();
    self.isInitialized = true;
  },
};
</script>
<style scoped>
.card-1 {
  border-radius: 13px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: unset !important;
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.card-2 {
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: unset !important;
  width: 100%;
  height: 500px;
  flex-shrink: 0;
}

.card-3 {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 160px;
  flex-shrink: 0;
}

.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.gradient-red {
  background: -webkit-linear-gradient(red, yellow);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-purple {
  background: -webkit-linear-gradient(#9747ff, #5179ef);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modern-field {
  margin-top: 8px;
}

.modern-field :deep(.v-field) {
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: unset !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: #e0e0e0 !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field:hover :deep(.v-field__outline) {
  border-color: #e0e0e0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

.modern-textarea {
  margin-top: 8px;
}

.modern-textarea :deep(.v-field) {
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

/* =============================================================================
   MODERN CHECKBOX STYLES
   ============================================================================= */
/* .modern-checkbox :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-checkbox :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-checkbox :deep(.v-selection-control--dirty) {
  border-color: rgba(25, 118, 210, 0.3);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
} */

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* .search-btn {
  border-radius: 50% !important;
  width: 56px !important;
  height: 56px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
} */

@keyframes pulse {
  0% {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }

  50% {
    box-shadow: 0 4px 20px rgba(25, 118, 210, 0.6);
  }

  100% {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }
}

/* =============================================================================
   REPROCESS BUTTON ENHANCEMENT
   ============================================================================= */
.reprocess-btn {
  border-radius: 25px !important;
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%) !important;
  box-shadow: 0 4px 15px rgba(151, 71, 255, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.reprocess-btn:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(151, 71, 255, 0.4) !important;
}

.reprocess-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  .search-btn {
    width: 48px !important;
    height: 48px !important;
  }

  .search-btn .v-icon {
    font-size: 20px !important;
  }
}
</style>

<!-- Redesign css -->
<style scoped>
.main-page-div {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.redesign-main-page-container {
  padding: 24px;
}

.main-content-card {
  border-radius: 16px !important;
  border: 1px solid #DCDCDC !important;
  background: #FFF !important;
  overflow: hidden;
  padding: 15px 20px 0 20px !important;
}

/* Search Button */
.search-btn-circular {
  width: 56px !important;
  height: 56px !important;
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important;
  box-shadow: 0 4px 12px rgba(195, 46, 14, 0.3) !important;
  transition: all 0.2s ease;
}

.search-btn-circular:hover {
  box-shadow: 0 6px 16px rgba(195, 46, 14, 0.4) !important;
  transform: scale(1.05);
}

.search-btn-circular:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.4) !important;
}

.search-btn-circular:active:not(:disabled) {
  transform: translateY(0) scale(1) !important;
}

.search-btn-circular:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

/* Pulse animation when loading */
.search-btn-circular.loading {
  animation: pulse 2s infinite;
}

.search-btn-circular .v-icon {
  color: white !important;
  transition: transform 0.2s ease !important;
}

.search-btn-circular:hover:not(:disabled) .v-icon {
  transform: scale(1.1) !important;
}

/* table base */
:deep(thead) {
  background-color: #FFF2F2 !important;
  padding: 0 8px;
}

.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

/* Expandable text in table */
.expandable-text-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.text-collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 4.5em; /* 3 lines * 1.5 line-height */
}

.text-expanded {
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.expand-icon-btn {
  flex-shrink: 0;
  margin-top: 2px;
}

.expand-icon-btn:hover {
  background: rgba(0, 23, 99, 0.12) !important;
}

/* :end */
.dialog-title-border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.dialog-title {
  color: #171717;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.dialog-action-border-top {
  border-top: 1px solid #e0e0e0;
  padding: 10px 15px;
}

.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}
.border-section-wrapper{
  border-radius: 24px;
  padding: 15px 10px;
  border: 1px solid #a0a0a0;
  transition: all 0.3s ease;
  width: 100% !important;
}
</style>
